// src/contexts/translations.js
export const translations = {
  en: {
    about: "About Us",
    blog: "Blog",
    contact: "Contact",
    features: "Features",
    games: "Games",
    caseStudy: "Case Study",
    switchLanguage: "Switch to Turkish",
  },
  tr: {
    about: "Hakkımızda",
    blog: "Blog",
    contact: "İletişim",
    features: "Özellikler",
    games: "Oyunlar",
    caseStudy: "Vaka Çalışması",
    switchLanguage: "İngilizce'ye Geç",
  },
};
